export const buildProjectBudgetQueryParams = ({
  project_id,
  date_start,
  date_end,
  group_by,
  user_ids,
  with_expense_details,
}) => {
  const params = new URLSearchParams()

  if (project_id) {
    params.append('project_id', project_id)
  }

  if (date_start) {
    params.append('date_start', date_start)
  }

  if (date_end) {
    params.append('date_end', date_end)
  }

  if (group_by) {
    params.append('group_by', group_by)
  }

  if (user_ids?.length > 0) {
    user_ids.forEach((userId) => {
      params.append('user_id[]', userId)
    })
  }

  if (with_expense_details !== undefined) {
    params.append('with_expense_details', with_expense_details)
  }

  return params.toString()
}
